import React, { Component } from "react";
import axios from "axios";
const config = require("../config.json");

export default class ModifyPointsAdmin extends Component {
  state = {
    userId: "",
    points: "",
    kilometers: "",
    kgCO2: "",
    currentWeek: "",
    loading: false,
    message: "",
    messageType: "", // 'success' or 'error'
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    if (!this.state.userId) {
      this.setState({
        message: "User ID er påkrævet",
        messageType: "error",
      });
      return;
    }

    this.setState({ loading: true, message: "", messageType: "" });

    try {
      const payload = {
        userId: this.state.userId,
        points: parseFloat(this.state.points) || 0,
        kilometers: parseFloat(this.state.kilometers) || 0,
        kgCO2: parseFloat(this.state.kgCO2) || 0,
      };

      // Only include currentWeek if provided
      if (this.state.currentWeek) {
        payload.currentWeek = parseInt(this.state.currentWeek);
      }

      const res = await axios.patch(
        `${config.api.invokeUrl}/points/${this.state.userId}/modify`,
        payload
      );

      this.setState({
        loading: false,
        message: "Points opdateret succesfuldt!",
        messageType: "success",
        // Reset form
        userId: "",
        points: "",
        kilometers: "",
        kgCO2: "",
      });

      console.log("Response:", res.data);
    } catch (err) {
      console.log(err);
      this.setState({
        loading: false,
        message: `Fejl: ${err.response?.data?.error || err.message}`,
        messageType: "error",
      });
    }
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Modificer Points Admin</h1>
            <p className="subtitle is-5">
              Tilføj eller fjern points, kilometers og CO2
            </p>
            <br />
            <div className="columns">
              <div className="column is-half">
                <form onSubmit={this.handleSubmit}>
                  <div className="field">
                    <label className="label">User ID *</label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        name="userId"
                        value={this.state.userId}
                        onChange={this.handleInputChange}
                        placeholder="Enter user ID"
                        required
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label className="label">Current Week (valgfri)</label>
                    <div className="control">
                      <input
                        className="input"
                        type="number"
                        name="currentWeek"
                        value={this.state.currentWeek}
                        onChange={this.handleInputChange}
                        placeholder="Lad stå tom for at bruge kampagnens aktuelle uge"
                      />
                    </div>
                    <p className="help">
                      Hvis ikke angivet, bruges kampagnens aktuelle uge
                    </p>
                  </div>

                  <div className="field">
                    <label className="label">Points</label>
                    <div className="control">
                      <input
                        className="input"
                        type="number"
                        step="any"
                        name="points"
                        value={this.state.points}
                        onChange={this.handleInputChange}
                        placeholder="0 (positive or negative)"
                      />
                    </div>
                    <p className="help">
                      Brug positive værdier for at tilføje, negative for at
                      fjerne
                    </p>
                  </div>

                  <div className="field">
                    <label className="label">kg CO2</label>
                    <div className="control">
                      <input
                        className="input"
                        type="number"
                        step="any"
                        name="kgCO2"
                        value={this.state.kgCO2}
                        onChange={this.handleInputChange}
                        placeholder="0 (positive or negative)"
                      />
                    </div>
                    <p className="help">
                      Brug positive værdier for at tilføje, negative for at
                      fjerne
                    </p>
                  </div>
                  <div className="field">
                    <label className="label">Kilometers</label>
                    <div className="control">
                      <input
                        className="input"
                        type="number"
                        step="any"
                        name="kilometers"
                        value={this.state.kilometers}
                        onChange={this.handleInputChange}
                        placeholder="0 (positive or negative)"
                      />
                    </div>
                    <p className="help">
                      Brug positive værdier for at tilføje, negative for at
                      fjerne
                    </p>
                  </div>
                  <div className="field">
                    <div className="control">
                      <button
                        className={`button is-primary ${
                          this.state.loading ? "is-loading" : ""
                        }`}
                        type="submit"
                        disabled={this.state.loading}
                      >
                        Modificer Points
                      </button>
                    </div>
                  </div>

                  {this.state.message && (
                    <div
                      className={`notification ${
                        this.state.messageType === "success"
                          ? "is-success"
                          : "is-danger"
                      }`}
                    >
                      {this.state.message}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
